import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoPersonCircle } from "react-icons/io5";
import { MdArrowDropUp, MdOutlineLogout } from "react-icons/md";
import "./Bookfetch.css";
import {
  getAllKatBookSubjects,
  GetBookCountforAll,
  GetBookUnitSessions,
  GetUnitCountforAll,
  GetSessionCountforAll,
  fetchFeedbackQuestions,
  feedbackSubmit,
} from "../../Services/ApiService";
import CryptoJS from "crypto-js";
import Header from "../header/Header";
import Subload from "../../Assests_Url/subject_loading.gif";
import Bowser from "bowser";
import { toast } from "react-toastify";
import { IoMdAnalytics } from "react-icons/io";
import { VscFeedback } from "react-icons/vsc";
import { TiArrowBackOutline } from "react-icons/ti";
import ModalComponent from "../modalComponent/ModalComponent";
import {
  isMobile,
  isTablet,
  isBrowser,
  browserName,
  engineName,
} from "react-device-detect";

const Bookfetch = ({
  RoutesClick,
  NcertClick,
  selectedLang,
  setSelectedLang,
  subjectArr,
  setsubjectArr,
}) => {
  let KatbookUrl = `https://katbook.explorencertkatbook.com`;
  // let KatbookUrl = `http://localhost:8000`;

  const secretKey = "KampusNcrt";
  const key = "KPOSTKatBooks#$*(@#)!!";
  const UserProfileData = JSON.parse(localStorage.getItem("userData"));
  const encryptedSubjects = localStorage.getItem("encryptedSubjects");
  const decryptedSubjects = CryptoJS.AES.decrypt(encryptedSubjects, secretKey);
  const subjects = JSON.parse(decryptedSubjects.toString(CryptoJS.enc.Utf8));
  const usercode = localStorage.getItem("userCode");

  const UserToken = localStorage.getItem("token");

  const decrypteduserCode = CryptoJS.AES.decrypt(usercode, secretKey);
  const userrescode = JSON.parse(decrypteduserCode.toString(CryptoJS.enc.Utf8));
  const FeedBackView = localStorage.getItem("feedback");
  const decryptedRegUser = CryptoJS.AES.decrypt(userrescode, "!@#$%^");
  const RegUserRes = decryptedRegUser.toString(CryptoJS.enc.Utf8);

  const userid = localStorage.getItem("userID");
  const decrypteduserIDD = CryptoJS.AES.decrypt(userid, secretKey);
  const userresidd = JSON.parse(decrypteduserIDD.toString(CryptoJS.enc.Utf8));

  console.log(isBrowser, isMobile, isTablet, browserName, engineName, "browser info");
  

  const navigate = useNavigate();
  const [dropdown, setDropdown] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdown(false);
      }
    };

    window.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const [userName, setUserName] = React.useState([]);
  // const [subjectArr, setsubjectArr] = useState([]);
  console.log(subjectArr, "1212121212121");
  const [standardArr, setstandardArr] = useState([]);
  const [uniquestandardArr, setuniquestandardArr] = useState([]);
  const [userClassname, setuserClassname] = useState("");
  const [viewedBookName, setviewedBookName] = useState("");
  const [viewedUnitName, setviewedUnitName] = useState("");
  console.log(userClassname, "userClassname");
  const [addbookOpen, setaddbookOpen] = useState(false);
  const [coverReportOpen, setCoverReportOpen] = useState(false);
  const [coverUnitOpen, setCoverUnitOpen] = useState(false);
  const [coverSessionOpen, setCoverSessionOpen] = useState(false);
  const [coverageReport, setcoverageReport] = useState([]);
  const [coverageReportUnit, setcoverageReportUnit] = useState([]);
  const [coverageReportSession, setcoverageReportSession] = useState([]);
  const [booklistloading, setbooklistloading] = useState(true);
  const [bookunitSessions, setbookunitSessions] = useState([]);
  const [info, setInfo] = useState({});
  const [quesSections, setquesSections] = useState([]);
  const [quesData, setquesData] = useState([]);
  const [feedbackbtnstatus, setfeedbackbtnstatus] = useState(false);
  const [answers, setAnswers] = useState({});
  console.log(answers, "answersanswers");

  const grouped = subjectArr.reduce((acc, item) => {
    const name = item.className;
    if (!acc[name]) acc[name] = [];
    acc[name].push(item);
    return acc;
  }, {});

  const MAIN_CLASSES = ["Class 1", "Class 6", "Class 12"];
  const AVAILABLE_CLASSES = MAIN_CLASSES.filter((cls) => grouped[cls]);

  console.log(grouped, "121212", MAIN_CLASSES);

  const mainClassGroups = {};
  const sindoorClassGroups = {};

  Object.keys(grouped).forEach((className) => {
    if (MAIN_CLASSES.includes(className)) {
      mainClassGroups[className] = grouped[className];
    } else {
      if (!sindoorClassGroups["Sindoor Books"])
        sindoorClassGroups["Sindoor Books"] = [];
      sindoorClassGroups["Sindoor Books"].push(...grouped[className]);
    }
  });

  const [active, setActive] = useState("");

  // run only if active not already set
  useEffect(() => {
    if (!active && AVAILABLE_CLASSES.length > 0) {
      if (AVAILABLE_CLASSES.includes("Class 6")) {
        setActive("Class 6");
      } else if (AVAILABLE_CLASSES.includes("Class 1")) {
        setActive("Class 1");
      } else if (AVAILABLE_CLASSES.includes("Class 12")) {
        setActive("Class 12");
      } else {
        setActive(AVAILABLE_CLASSES[0]);
      }
    }
  }, [AVAILABLE_CLASSES, active]);

  const coverageArr = [
    {
      label: "Sessions Covered",
      totalCount: "sessionCount",
      studentCount: "contentCompleted",
      type: "sessions",
      class: "coverthreejai111",
      translate: "sessioncovered",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: false,
    },
    {
      label: "Enhanced Content Viewed",
      totalCount: "totalAddContentCount",
      studentCount: "addContentCompleted",
      type: "addContent",
      class: "coverthreejai333",
      translate: "enhanceContent",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: true,
    },
    {
      label: "Concept Videos Viewed",
      totalCount: "totalConceptVideos",
      studentCount: "conceptVideosViewed",
      type: "concept",
      class: "coverthreejai444",
      translate: "conceptvideo",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: true,
    },
    {
      label: "Explanation Videos Viewed",
      totalCount: "totalTeachingVideos",
      studentCount: "teachingVideosViewed",
      type: "teaching",
      class: "coverthreejai555",
      translate: "teachingvideo",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: true,
    },
    {
      label: "3D Videos Viewed",
      totalCount: "total3DVideo",
      studentCount: "threeDVideosViewed",
      type: "3dvideo",
      class: "coverthreejai111",
      translate: "threeDVideo",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: true,
    },
    {
      label: "3D Models Viewed",
      totalCount: "total3DModel",
      studentCount: "threeDModelViewed",
      type: "3dmodel",
      class: "coverthreejai222",
      translate: "threeDModel",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: true,
    },
    {
      label: "3D Activities Viewed",
      totalCount: "total3DActivity",
      studentCount: "threeDActivitiesViewed",
      type: "3dactivity",
      class: "coverthreejai333",
      translate: "threeDActivity",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: true,
    },
    {
      label: "2D Animations Viewed",
      totalCount: "total2DAnimation",
      studentCount: "twoDAnimationViewed",
      type: "2danimation",
      class: "coverthreejai444",
      translate: "twoDAnimation",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: true,
    },
    {
      label: "Lesson Plan Viewed",
      totalCount: "totalLessonPlan",
      studentCount: "lessonPlanViewed",
      type: "lessonplan",
      class: "coverthreejai555",
      translate: "lessonPlan",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: true,
    },
    {
      label: "Virtual Lab Experiments Viewed",
      totalCount: "totalVirtualLab",
      studentCount: "virtualLabViewed",
      type: "virtuallab",
      class: "coverthreejai111",
      translate: "virtualLab",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: true,
    },
    {
      label: "Notes Made",
      totalCount: "",
      studentCount: "notesCount",
      type: "notes",
      class: "",
      translate: "notes",
    },
    {
      label: "Book Marks Made",
      totalCount: "",
      studentCount: "bookmarkCount",
      type: "bookmarks",
      class: "",
      translate: "bookmarks",
    },
    {
      label: "Highlights Made",
      totalCount: "",
      studentCount: "highlighterCount",
      type: "highlights",
      class: "",
      translate: "highlights",
    },
    {
      label: "Hyperlink Made",
      totalCount: "",
      studentCount: "hyperlinkCount",
      type: "hyperlinks",
      class: "",
      translate: "hyperlinks",
    },
    {
      label: "Clarification Posted",
      totalCount: "",
      studentCount: "clarifyCount",
      type: "clarify",
      class: "",
      translate: "clarify",
    },
    {
      label: "Comments Posted",
      totalCount: "",
      studentCount: "commentCount",
      type: "comments",
      class: "",
      translate: "comments",
    },
  ];

  const [showFeedbackClass, setShowFeedbackClass] = useState(false);

  const feedbackRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close showFeedbackClass if clicking outside the feedback dropdown
      if (feedbackRef.current && !feedbackRef.current.contains(event.target)) {
        setShowFeedbackClass(false);
        setActiveIcon(null);
      }
    };

    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const location = useLocation();

  const handleFeedbackClick = (event) => {
    // event.stopPropagation(); // Prevent immediate window click close
    // existing onClick logic for feedback icon
    setuserClassname(UserProfileData?.class);
    getFeedbackFuc(
      UserProfileData?.class,
      UserProfileData?.userTypeId?.usertype.toLowerCase()
    );
    setShowFeedbackClass(false);
    setfeedbackbtnstatus(!feedbackbtnstatus);
    setCoverSessionOpen(false);
    setCoverUnitOpen(false);
    setCoverReportOpen(false);
    // if (feedbackbtnstatus === true) {
    //   if (standardArr.length > 1) {
    //     setShowFeedbackClass(true);
    //     setfeedbackbtnstatus(true);
    //     setActiveIcon("feedback");
    //     return;
    //   } else if (standardArr.length === 1) {
    //     setActiveIcon(null);
    //     setfeedbackbtnstatus(false);
    //     return;
    //   }
    // }
    setActiveIcon(activeIcon === "feedback" ? null : "feedback");
    // if (standardArr.length > 1) {
    //   setShowFeedbackClass((prev) => {
    //     const newShow = !prev;
    //     setActiveIcon(newShow ? "feedback" : null);
    //     return newShow;
    //   });
    // } else if (standardArr.length === 1) {
    //   const classStr = standardArr[0]?.variableName?.split(" ")[1];
    //   setuserClassname(classStr);
    //   setfeedbackbtnstatus(!feedbackbtnstatus);
    //   setCoverSessionOpen(false);
    //   setCoverUnitOpen(false);
    //   setCoverReportOpen(false);
    //   setShowFeedbackClass(false);
    // }
  };

  useEffect(() => {
    if (location.state?.openFeedback) {
      handleFeedbackClick();
      // Clear the state to prevent reopening on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  useEffect(() => {
    const username = localStorage.getItem("username");

    setUserName(username);
    const encryptedStandard = localStorage.getItem("encryptedStandard");

    if (
      encryptedStandard !== null &&
      encryptedStandard !== undefined &&
      encryptedStandard !== ""
    ) {
      console.log(subjects);
      const decryptedStandard = CryptoJS.AES.decrypt(
        encryptedStandard,
        secretKey
      );
      const standard = JSON.parse(
        decryptedStandard.toString(CryptoJS.enc.Utf8)
      );
      setstandardArr(standard);
      console.log(standard, "standardstandard");
      const uniquestandardData = [
        ...new Map(
          standard.map((item123) => [item123?.variableName, item123])
        ).values(),
      ];
      setuniquestandardArr(uniquestandardData);

      if (uniquestandardData.length === 1) {
        const classStr = uniquestandardData[0]?.variableName?.split(" ")[1];
        setuserClassname(classStr);
        getFeedbackFuc(
          classStr,
          UserProfileData?.userTypeId?.usertype.toLowerCase()
        );
      } else {
        // let specifyClass =
        //   uniquestandardData.filter((x) => x?.variableName === "Class 12")?.length > 0
        //     ? "12"
        //     : uniquestandardData.filter((x) => x?.variableName === "Class 6")?.length > 0
        //     ? "6"
        //     : "1";
        // setuserClassname(specifyClass);
        // console.log(specifyClass, "standardstandard");
      }
      // const storedUserData = localStorage.getItem('userData');
      // if (storedUserData) {
      //   const parsedUserData = JSON.parse(storedUserData);
      //   setUserData(parsedUserData);
      // }

      getSubjectDetails();
      // getFeedbackFuc(
      //   userClassname,
      //   UserProfileData?.userTypeId?.usertype.toLowerCase()
      // );
    } else {
      // const currentVersion = localStorage.getItem("app_version");
      localStorage.removeItem("userID");
      localStorage.removeItem("userCode");
      localStorage.removeItem("username");
      localStorage.removeItem("encryptedMedium");
      localStorage.removeItem("encryptedSubjects");
      localStorage.removeItem("encryptedStandard");
      localStorage.removeItem("token");
      localStorage.removeItem("userData");
      localStorage.removeItem("IsUserAuth");
      localStorage.removeItem("userType");
      localStorage.removeItem("username");
      // localStorage.clear();
      // localStorage.setItem("app_version", currentVersion);
      navigate("/");
    }
  }, []);

  useEffect(() => {
    const browser = Bowser.getParser(window.navigator.userAgent);
    const result = browser.getResult();

    console.log(result,
      "browser info"
    );

    setInfo({
      browser: result.browser.name,
      os: result.os.name,
      platform: result.platform.type, // desktop / mobile / tablet
    });

    console.log(
      {
        browser: result.browser.name,
        os: result.os.name,
        platform: result.platform.type, // desktop / mobile / tablet
      },
      "browser info"
    );
  }, []);

  const handleLogout = () => {
    // const currentVersion = localStorage.getItem("app_version");
    localStorage.removeItem("userID");
    localStorage.removeItem("userCode");
    localStorage.removeItem("username");
    localStorage.removeItem("encryptedMedium");
    localStorage.removeItem("encryptedSubjects");
    localStorage.removeItem("encryptedStandard");
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
    localStorage.removeItem("IsUserAuth");
    localStorage.removeItem("userType");
    localStorage.removeItem("username");
    // localStorage.clear();
    // localStorage.setItem("app_version", currentVersion);
    navigate("/");
  };

  const getFeedbackFuc = async (className, userType) => {
    const cleanClass = className?.replace(/^Class\s*/i, "");
    let response;
    response = await fetchFeedbackQuestions(cleanClass, userType);
    if (response?.success && response?.data?.length > 0) {
      const uniqueAttrId = [
        ...new Map(
          response?.data.map((item123) => [item123?.section?._id, item123])
        ).values(),
      ];
      console.log(uniqueAttrId, "uniqueAttrId");
      console.log(response?.data, "uniqueAttrId");
      setquesSections(uniqueAttrId);
      setquesData(response?.data);
    } else {
      setquesSections([]);
      setquesData([]);
    }
  };

  const currentClassAnswers = answers[userClassname] || {};
  const allAnswered =
    quesData.length > 0 &&
    quesData.every(
      (q) =>
        currentClassAnswers[q._id] && currentClassAnswers[q._id].trim() !== ""
    );

  const [feedBackModalOpen, setFeedBackModalOpen] = useState(false);
  const SubmitFeedback = async () => {
    try {
      let answersToSubmit = [];

      quesData.forEach((item) => {
        let answer = "";

        if (item?.questionType === "radio") {
          // radio selected value
          const selected = document.querySelector(
            `input[name="${item?._id}"]:checked`
          );
          if (selected) {
            answer = selected.value;
          }
        } else if (item?.questionType === "textarea") {
          // textarea value
          const textarea = document.getElementById(`textarea-${item?._id}`);
          if (textarea) {
            answer = textarea.value;
          }
        }

        answersToSubmit.push({
          questionId: item?._id,
          answer: answer,
          className: userClassname,
        });
      });

      let bod = {
        answers: answersToSubmit,
      };
      let response = await feedbackSubmit(bod);
      if (response.success === true) {
        setFeedBackModalOpen(true);
        setCoverUnitOpen(false);
        setCoverSessionOpen(false);
        setCoverReportOpen(false);
        setfeedbackbtnstatus(false);
        setActiveIcon(null);
        setAnswers({});
        localStorage.setItem("feedback", true);
      } else {
        setFeedBackModalOpen(false);
        toast.error(response.error);
      }
    } catch (e) {
      console.log(e, "error");
    }
  };

  const getSubjectDetails = async (BookIDs) => {
    let allBooks;
    if (BookIDs) {
      allBooks = [
        ...BookIDs,
        // "68c8081ac55d84a7149f2228",
        // "68c808c8c55d84a7149f27d0",
      ];
    } else {
      allBooks = subjects.map((subject) => subject._id);
      allBooks = [
        ...allBooks,
        // "68c8081ac55d84a7149f2228",
        // "68c808c8c55d84a7149f27d0",
      ];
    }
    // console.log(BookIDs,"BookIDsBookIDs");
    // console.log(subjects.map(subject => subject._id),"BookIDsBookIDs");
    try {
      let bod = {
        bookIds: allBooks,
      };

      let res = await getAllKatBookSubjects(bod);
      if (res?.success === true) {
        setsubjectArr(res.units);
      } else {
        console.log(res.error, res, "testtstst");
      }
    } catch (error) {
      console.log(error);
    }
    setbooklistloading(false);
  };

  const FetchAllBooks = async (subjectList) => {
    setcoverageReport([]);
    setbooklistloading(true);
    if (subjectList?.length !== 0) {
      const value = [];
      (async () => {
        // await subjectList.map(async (x, index) => {
        for (let as = 0; as < subjectList?.length; as++) {
          let response;
          const CountBody = {
            bookId: subjectList[as]?.bookId,
            studentId: UserProfileData?.userId,
            refInstID: "789",
            refMediumID: subjectList[as]?.medium ? subjectList[as]?.medium : 1,
            refStandardID: subjectList[as]?.standard,
            refSubjectID: subjectList[as]?.bookId,
          };
          // console.log("unit count 2","unit analytics");
          response = await GetBookCountforAll(CountBody);

          if (response?.success) {
            const StdID =
              subjects.filter((q) => q._id === subjectList[as]?.bookId).length >
              0
                ? subjects.filter((q) => q._id === subjectList[as]?.bookId)[0]
                    ?.parentVaribaleId?.parentVaribaleId?.variableName
                : "";

            let resBooks = {
              bookId: subjectList[as]?.bookId,
              bookName: subjectList[as]?.book,
              className: StdID,
              booksProgress: response?.value,
            };

            value.push(resBooks);
            console.log(value, "setcoverageReport");
            // ✅ use functional update to avoid stale state
            setcoverageReport((prev) => [...prev, resBooks]);
            setbooklistloading(false);
          }

          // if (as + 1 === subjectList?.length) {
          //   setTimeout(() => {
          //     setcoverageReport(value);
          //   }, 100);
          // }
        }
        // });
      })();
    } else {
      setcoverageReport([]);
      setbooklistloading(false);
    }
  };

  const FetchAllUnitAnalytics = async (bookId, dataList) => {
    setcoverageReportUnit([]);
    setbooklistloading(true);
    if (dataList?.length !== 0) {
      const value = [];
      (async () => {
        for (let as = 0; as < dataList?.length; as++) {
          console.log(dataList[as], "setcoverageReport");

          if (as > 0) {
            let response;
            const CountBody = {
              unitId: dataList[as]?.UnitId,
              studentId: UserProfileData?.userId,
              refInstID: "789",
              refMediumID:
                subjectArr.filter((a) => a?.bookId === bookId)?.length > 0
                  ? subjectArr.filter((a) => a?.bookId === bookId)[0]?.medium
                  : 1,
              refStandardID:
                subjectArr.filter((a) => a?.bookId === bookId)?.length > 0
                  ? subjectArr.filter((a) => a?.bookId === bookId)[0]?.standard
                  : "",
              refSubjectID: bookId,
            };
            // console.log("unit count 2","unit analytics");
            response = await GetUnitCountforAll(CountBody);

            if (response?.success) {
              let resBooks = {
                bookId: bookId,
                unitId: dataList[as]?.UnitId,
                unitName: dataList[as]?.UnitName,
                booksProgress: response?.value,
              };
              console.log(resBooks, "setcoverageReport");
              value.push(resBooks);
              console.log(value, "setcoverageReport");
              setcoverageReportUnit((prev) => [...prev, resBooks]);
              setbooklistloading(false);
            }

            // if (as + 1 === dataList?.length) {
            //   setTimeout(() => {
            //     setcoverageReportUnit(value);
            //   }, 100);
            // }
          }
        }

        // setbooklistloading(false);
      })();
    } else {
      setcoverageReportUnit([]);
      setbooklistloading(false);
    }
  };

  const FetchAllSessionAnalytics = async (bookId, dataList) => {
    // console.log(dataList, "setcoverageReport");
    setcoverageReportSession([]);
    setbooklistloading(true);
    if (dataList?.length !== 0) {
      const value = [];
      (async () => {
        for (let as = 0; as < dataList?.length; as++) {
          let response;
          const CountBody = {
            sessionId: dataList[as]?.SessionId,
            studentId: UserProfileData?.userId,
            refInstID: "789",
            refMediumID:
              subjectArr.filter((a) => a?.bookId === bookId)?.length > 0
                ? subjectArr.filter((a) => a?.bookId === bookId)[0]?.medium
                : 1,
            refStandardID:
              subjectArr.filter((a) => a?.bookId === bookId)?.length > 0
                ? subjectArr.filter((a) => a?.bookId === bookId)[0]?.standard
                : "",
            refSubjectID: bookId,
          };
          // console.log("unit count 2","unit analytics");
          response = await GetSessionCountforAll(CountBody);

          if (response?.success) {
            let resBooks = {
              bookId: bookId,
              sessionId: dataList[as]?.SessionId,
              SessionName: dataList[as]?.SessionName,
              booksProgress: response?.value,
            };
            console.log(resBooks, "setcoverageReport");
            value.push(resBooks);
            console.log(value, "setcoverageReport");
            setcoverageReportSession((prev) => [...prev, resBooks]);
            setbooklistloading(false);
          }

          // if (as + 1 === dataList?.length) {
          //   setTimeout(() => {
          //     setcoverageReportSession(value);
          //   }, 100);
          // }
        }

        // setbooklistloading(false);
      })();
    } else {
      setcoverageReportSession([]);
      setbooklistloading(false);
    }
  };

  const FetchAllUnitsSessions = async (bookId) => {
    let response = await GetBookUnitSessions(bookId);
    if (response?.success && response?.variable?.length > 0) {
      setbookunitSessions(response?.variable[0]?.Units);
      FetchAllUnitAnalytics(bookId, response?.variable[0]?.Units);
    }
  };

  const handleBookClick = (subjectId) => {
    console.log(subjectId, "subjectId");
    const encryptedStandard = localStorage.getItem("encryptedStandard");
    const decryptedStandard = CryptoJS.AES.decrypt(
      encryptedStandard,
      secretKey
    );
    const standard = JSON.parse(decryptedStandard.toString(CryptoJS.enc.Utf8));

    const encryptedMedium = localStorage.getItem("encryptedMedium");
    const decryptedMedium = CryptoJS.AES.decrypt(encryptedMedium, secretKey);
    const medium = JSON.parse(decryptedMedium.toString(CryptoJS.enc.Utf8));

    const usercode = localStorage.getItem("userCode");

    const decrypteduserCode = CryptoJS.AES.decrypt(usercode, secretKey);
    const userrescode = JSON.parse(
      decrypteduserCode.toString(CryptoJS.enc.Utf8)
    );

    const decryptedRegUser = CryptoJS.AES.decrypt(userrescode, "!@#$%^");
    const RegUserRes = decryptedRegUser.toString(CryptoJS.enc.Utf8);

    const userid = localStorage.getItem("userID");
    const decrypteduserIDD = CryptoJS.AES.decrypt(userid, secretKey);
    const userresidd = JSON.parse(decrypteduserIDD.toString(CryptoJS.enc.Utf8));

    const stdid = standard.map((standard) => standard._id);
    const mediumid = medium._id;
  };

  const [iconclick, seticonclick] = useState(false);
  const [activeIcon, setActiveIcon] = useState(null);

  const bookFetchGo = () => {
    setActiveIcon(null);
    setCoverSessionOpen(false);
    setCoverUnitOpen(false);
    setCoverReportOpen(false);
    setShowFeedbackClass(false);
    setfeedbackbtnstatus(false);
  };

  const [activeTabHeader, setActiveTabHeader] = useState("MyKatbook");
  const [studentregisterModal, setStudentRegisterModal] = useState(false);
  const [ParentregisterModal, setParentRegisterModal] = useState(false);
  const [TeacherregisterModal, setTeacherregisterModal] = useState(false);
  const [AdminregisterModal, setAdminregisterModal] = useState(false);
  const handleTabClickHeader = (tab) => {
    setActiveTabHeader(tab);
  };
  return (
    <div className="spacing">
      <Header
        handleFeedbackClick={handleFeedbackClick}
        handleTabClick={handleTabClickHeader}
        studentregisterModal={studentregisterModal}
        setStudentRegisterModal={setStudentRegisterModal}
        ParentregisterModal={ParentregisterModal}
        setParentRegisterModal={setParentRegisterModal}
        TeacherregisterModal={TeacherregisterModal}
        setTeacherregisterModal={setTeacherregisterModal}
        // userAuth={localStorage.getItem("IsUserAuth")}
        setaddbookOpen={setaddbookOpen}
        addbookOpen={addbookOpen}
        setActiveIcon={setActiveIcon}
        activeTab={activeTabHeader}
        AdminregisterModal={AdminregisterModal}
        setAdminregisterModal={setAdminregisterModal}
        bookFetchGo={bookFetchGo}
        standardArr={standardArr}
        RoutesClick={RoutesClick}
        NcertClick={NcertClick}
        selectedLang={selectedLang}
        setSelectedLang={setSelectedLang}
        setstandardArr={setstandardArr}
        setuniquestandardArr={setuniquestandardArr}
        RefreshSubjects={(bookArray) => getSubjectDetails(bookArray)}
      />

      {dropdown && (
        <div
          className="d-flex flex-column gap-2 backgroundeffect "
          ref={dropdownRef}
        >
          <div className="iconshowCardBookfethch">
            <MdArrowDropUp size={30} color="#fff" />
          </div>
          <div className="account"> Account</div>
          <div className="sections  px-3 py-1">
            <IoPersonCircle size={20} />
            &nbsp;{userName}
          </div>
          {/* <div className='key px-3 py-1'><RiPushpinFill size={20} />&nbsp; @122334</div> */}
          <div className="sections px-3 py-1" onClick={handleLogout}>
            <MdOutlineLogout size={20} />
            &nbsp; Log Out
          </div>
        </div>
      )}

      <div className="pad-lef-rig paddingBookviewDown">
        <div>
          <div className="background">
            <div className="book_fetch px-3 py-2">
              <div className="login-name d-flex">
                {(coverReportOpen ||
                  coverUnitOpen ||
                  coverSessionOpen ||
                  feedbackbtnstatus) && (
                  <div
                    className="katbooktext "
                    onClick={() => {
                      if (coverSessionOpen) {
                        setCoverSessionOpen(false);
                        setCoverUnitOpen(true);
                        setCoverReportOpen(false);
                        setfeedbackbtnstatus(false);
                        setviewedUnitName("");
                      } else if (coverUnitOpen) {
                        setCoverUnitOpen(false);
                        setCoverSessionOpen(false);
                        setCoverReportOpen(true);
                        setfeedbackbtnstatus(false);
                        setviewedBookName("");
                      } else if (coverReportOpen) {
                        setCoverUnitOpen(false);
                        setCoverSessionOpen(false);
                        setCoverReportOpen(!coverReportOpen);
                        setActiveIcon(null);
                        setfeedbackbtnstatus(false);
                        setShowFeedbackClass(false);
                      } else if (feedbackbtnstatus) {
                        setCoverUnitOpen(false);
                        setCoverSessionOpen(false);
                        setCoverReportOpen(false);
                        setfeedbackbtnstatus(false);
                        setActiveIcon(null);
                        setAnswers({});
                      }
                    }}
                  >
                    <TiArrowBackOutline className="cursor-pointer" />
                  </div>
                )}
                &nbsp;&nbsp;
                {coverReportOpen || coverUnitOpen || coverSessionOpen ? (
                  <div className="katbooktext">
                    Coverage Report of{" "}
                    {UserProfileData?.userTypeId?.usertype === "Parent"
                      ? `${UserProfileData?.studentId?.firstName} ${UserProfileData?.studentId?.lastName}'s Katbook`
                      : `${UserProfileData?.firstName}'s Katbook`}
                  </div>
                ) : (
                  <div className="katbooktext capiterm">
                    {UserProfileData?.userTypeId?.usertype === "Parent"
                      ? `${UserProfileData?.studentId?.firstName} ${UserProfileData?.studentId?.lastName}'s KATBOOKs`
                      : `${UserProfileData?.firstName}'s KATBOOKs`}
                  </div>
                )}
              </div>

              <div className="d-flex align-items-center gap-4">
                {(UserProfileData?.userTypeId?.usertype === "Teacher" ||
                  UserProfileData?.userTypeId?.usertype === "Student") &&
                  UserProfileData?.class &&
                  FeedBackView !== "true" && (
                    <div
                      className={
                        activeIcon === "feedback"
                          ? "iconClickBookfetch"
                          : "IconBookFetchs"
                      }
                      onClick={handleFeedbackClick}
                    >
                      <VscFeedback
                        title="Feedback"
                        color={activeIcon === "feedback" ? "#fff" : "#000"}
                      />

                      {showFeedbackClass && (
                        <div
                          className="d-flex flex-column gap-2 backgroundeffectFeedback"
                          ref={feedbackRef}
                        >
                          <div className="iconshowCardBookfethchClass">
                            <MdArrowDropUp size={30} color="#fff" />
                          </div>
                          <div className="section py-1">
                            {uniquestandardArr.map((item, index) => (
                              <div
                                key={index}
                                className="py-1 px-3 classListview"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const classStr =
                                    item?.variableName?.split(" ")[1];
                                }}
                              >
                                {item.variableName}
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                <div
                  className={
                    activeIcon === "analytics"
                      ? "iconClickBookfetch"
                      : "IconBookFetchs"
                  }
                  onClick={() => {
                    if (coverSessionOpen) {
                      setCoverSessionOpen(false);
                      setCoverUnitOpen(true);
                      setCoverReportOpen(false);
                      setfeedbackbtnstatus(false);
                      setShowFeedbackClass(false);
                      setActiveIcon("analytics");
                      setviewedUnitName("");
                    } else if (coverUnitOpen) {
                      setCoverUnitOpen(false);
                      setCoverSessionOpen(false);
                      setCoverReportOpen(true);
                      setfeedbackbtnstatus(false);
                      setShowFeedbackClass(false);
                      setActiveIcon("analytics");
                      setviewedBookName("");
                    } else {
                      setCoverUnitOpen(false);
                      setCoverSessionOpen(false);
                      setCoverReportOpen(!coverReportOpen);
                      setActiveIcon((prev) =>
                        prev === "analytics" ? null : "analytics"
                      );
                      setfeedbackbtnstatus(false);
                      setShowFeedbackClass(false);
                      if (coverReportOpen === false) {
                        FetchAllBooks(subjectArr);
                      }
                    }
                  }}
                >
                  <IoMdAnalytics
                    title="Coverage Report"
                    color={
                      activeIcon === "analytics"
                        ? "rgba(255, 255, 255, 1)"
                        : "#000"
                    }
                  />
                </div>
              </div>
            </div>

            {booklistloading ? (
              <>
                <div
                  style={{
                    height: window.innerHeight - 210 + "px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={Subload} alt="" style={{ width: "25%" }} />
                </div>
              </>
            ) : (
              <>
                {!coverReportOpen &&
                  !coverUnitOpen &&
                  !coverSessionOpen &&
                  !feedbackbtnstatus && (
                    <>
                      <div
                        className="book-show"
                        style={{
                          marginTop: 20,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            border: "1px solid #2970b5",
                            borderRadius: 50,
                            overflow: "hidden",
                            backgroundColor: "#fff",
                          }}
                        >
                        <>
                          {AVAILABLE_CLASSES.map((cls, index) => (
                            <button
                              key={cls}
                              onClick={() => setActive(cls)}
                              style={{
                                backgroundColor:
                                  active === cls ? "#2970b5" : "#fff",
                                color: active === cls ? "#fff" : "#000",
                                border: "none",
                                padding: "10px 24px",
                                fontSize: "14px",
                                cursor: "pointer",
                                transition: "all 0.3s ease",
                                borderRight:
                                  index !== MAIN_CLASSES.length - 1
                                    ? "1px solid #ccc"
                                    : "none",
                              }}
                            >
                              {cls}
                            </button>
                          ))}
                        </>
                        
                        </div>
                      </div>

                      <div className="book-show py-3">
                        {(active === "Sindoor Books"
                          ? sindoorClassGroups["Sindoor Books"] || []
                          : mainClassGroups[active] || []
                        ).map((x) => {
                          const BooksText = `${
                            x.path.split('"parentVaribaleId"')[0]
                          }"parentVaribaleId":{"username":"${userresidd}~NCERT","code":"${UserToken.replaceAll('Bearer ','')}"}}/${
                            x?.standard
                          }/${x?.bookId}/789/${x?.medium}`;

                          const Bookencrypted = CryptoJS.AES.encrypt(
                            JSON.stringify(BooksText),
                            key
                          ).toString();

                          const StdID =
                            subjects.filter((q) => q._id === x._id).length > 0
                              ? subjects.filter((q) => q._id === x._id)[0]
                                  ?.parentVaribaleId?.parentVaribaleId
                                  ?.variableName
                              : "";

                          return (
                            <div
                              className="img-cover d-flex flex-column gap-2 align-items-center justify-content-start color"
                              style={{
                                width: "20%",
                                padding: "15px",
                              }}
                            >
                              <div
                                className="d-flex justify-content-center w-100"
                                key={x.bookId}
                                onClick={() => {
                                  var newOpen = window.open(
                                    `${KatbookUrl}/#/auth/book/${Bookencrypted}`
                                  );
                                  if (
                                    newOpen == null ||
                                    typeof newOpen == "undefined"
                                  ) {
                                    alert("Turn off your pop-up blocker!");
                                  }
                                }}
                              >
                                <img
                                  className="bookwidhei"
                                  src={x.coverImage}
                                  alt="books"
                                />
                              </div>
                              <div className="subjectname subjectnameWidthnowrap">
                                {x.book}
                              </div>
                              {/* <div className="subjectname">
                                {UserProfileData?.userTypeId?.usertype ===
                                  "Teacher" && StdID
                                  ? StdID
                                  : UserProfileData?.userTypeId?.usertype ===
                                    "Student" && StdID
                                    ? StdID
                                    : UserProfileData?.userTypeId?.usertype ===
                                      "Admin" && StdID
                                      ? StdID
                                      : ""}
                              </div> */}
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}

                {coverReportOpen &&
                  !coverUnitOpen &&
                  !coverSessionOpen &&
                  !feedbackbtnstatus && (
                    <div className="row justify-content-start py-3 padtomobile padtwoperen">
                      {coverageReport?.length > 0 &&
                        coverageReport?.map((subject) => (
                          <div className="col-md-4 mb-4 d-flex justify-content-center">
                            <div className="report-card w-100">
                              {/* Subject Title */}

                              <h3
                                className="report-title text-center cursor-pointer"
                                onClick={() => {
                                  setCoverUnitOpen(true);
                                  setCoverReportOpen(false);
                                  setCoverSessionOpen(false);
                                  setviewedBookName(
                                    `${
                                      subject?.className
                                        ? `${subject?.className} - `
                                        : ``
                                    }${subject.bookName}`
                                  );
                                  FetchAllUnitsSessions(subject?.bookId);
                                }}
                              >
                                {subject.bookName}{" "}
                                {subject?.className
                                  ? `(${subject?.className})`
                                  : ``}
                              </h3>

                              <div className="d-flex gap10px">
                                <div className="report-circle">
                                  {" "}
                                  <div>
                                    {" "}
                                    {subject?.booksProgress?.student
                                      ?.overAllStudentCount > 0
                                      ? Math.round(
                                          (subject?.booksProgress?.student
                                            ?.overAllStudentCount *
                                            100) /
                                            subject?.booksProgress?.total
                                              ?.overAllCount
                                        )
                                      : 0}
                                    %{" "}
                                  </div>{" "}
                                  <div className="report-circlespan">
                                    Book Coverage
                                  </div>{" "}
                                </div>

                                <div className="w-100">
                                  {/* Items */}
                                  <div className="report-items">
                                    {coverageArr?.length > 0 &&
                                      coverageArr?.map((item) => (
                                        <>
                                          {subject?.booksProgress?.total[
                                            item?.totalCount
                                          ] &&
                                          subject?.booksProgress?.total[
                                            item?.totalCount
                                          ] > 0 &&
                                          item?.bookStatus ? (
                                            <div className="report-item">
                                              <div className="report-label d-flex justify-content-between">
                                                <span>
                                                  {item.label}{" "}
                                                  <span className="font-weight-600">
                                                    {
                                                      subject?.booksProgress
                                                        ?.student[
                                                        item?.studentCount
                                                      ]
                                                    }
                                                    /
                                                    {
                                                      subject?.booksProgress
                                                        ?.total[
                                                        item?.totalCount
                                                      ]
                                                    }
                                                  </span>
                                                </span>
                                                <span className="font-weight-600">
                                                  {`${
                                                    subject?.booksProgress
                                                      ?.total[
                                                      item?.totalCount
                                                    ] === 0
                                                      ? 0
                                                      : subject?.booksProgress
                                                          ?.student[
                                                          item?.studentCount
                                                        ]
                                                      ? subject?.booksProgress
                                                          ?.student[
                                                          item?.studentCount
                                                        ] >
                                                        subject?.booksProgress
                                                          ?.total[
                                                          item?.totalCount
                                                        ]
                                                        ? "100"
                                                        : Math.round(
                                                            (subject
                                                              ?.booksProgress
                                                              ?.student[
                                                              item?.studentCount
                                                            ] *
                                                              100) /
                                                              subject
                                                                ?.booksProgress
                                                                ?.total[
                                                                item?.totalCount
                                                              ]
                                                          )
                                                      : 0
                                                  }%`}
                                                </span>
                                              </div>
                                              <div className="report-bar">
                                                <div
                                                  className="report-bar-fill"
                                                  style={{
                                                    width: `${
                                                      subject?.booksProgress
                                                        ?.total[
                                                        item?.totalCount
                                                      ] === 0
                                                        ? 0
                                                        : subject?.booksProgress
                                                            ?.student[
                                                            item?.studentCount
                                                          ]
                                                        ? subject?.booksProgress
                                                            ?.student[
                                                            item?.studentCount
                                                          ] >
                                                          subject?.booksProgress
                                                            ?.total[
                                                            item?.totalCount
                                                          ]
                                                          ? "100"
                                                          : Math.round(
                                                              (subject
                                                                ?.booksProgress
                                                                ?.student[
                                                                item
                                                                  ?.studentCount
                                                              ] *
                                                                100) /
                                                                subject
                                                                  ?.booksProgress
                                                                  ?.total[
                                                                  item
                                                                    ?.totalCount
                                                                ]
                                                            )
                                                        : 0
                                                    }%`,
                                                  }}
                                                >
                                                  {/* <span className="report-bar-percent">
                                      {`${subject?.booksProgress?.total[item?.totalCount] === 0 ? 0 : (subject?.booksProgress?.student[item?.studentCount] ? subject?.booksProgress?.student[item?.studentCount] > subject?.booksProgress?.total[item?.totalCount] ? "100" : Math.round((subject?.booksProgress?.student[item?.studentCount] * 100)/subject?.booksProgress?.total[item?.totalCount]) : 0)}%`}
                                    </span> */}
                                                </div>
                                              </div>
                                            </div>
                                          ) : item.totalCount === "" ? (
                                            <div className="report-item">
                                              <div className="report-label d-flex justify-content-between">
                                                <span>{item.label} </span>
                                                <span className="font-weight-600">
                                                  {
                                                    subject?.booksProgress
                                                      ?.student[
                                                      item?.studentCount
                                                    ]
                                                  }
                                                </span>
                                              </div>
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </>
                                      ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  )}

                {!coverReportOpen &&
                  coverUnitOpen &&
                  !coverSessionOpen &&
                  !feedbackbtnstatus && (
                    <div className="row justify-content-start py-3 padtwoperen">
                      {viewedBookName && (
                        <div className="d-flex mb-3">
                          <span className="title-crumb text-left">
                            {viewedBookName}
                          </span>
                          {viewedUnitName && (
                            <>
                              <span className="d-flex align-items-end">
                                {">>"}
                              </span>
                              <span className="title-crumb text-left">
                                {viewedUnitName}
                              </span>
                            </>
                          )}
                        </div>
                      )}
                      {coverageReportUnit?.length > 0 &&
                        coverageReportUnit?.map((subject) => (
                          <div className="col-md-4 mb-4 d-flex justify-content-center">
                            <div className="report-card w-100">
                              {/* Subject Title */}

                              <h3
                                className="report-title text-center cursor-pointer"
                                onClick={() => {
                                  console.log(
                                    bookunitSessions,
                                    "bookunitSessions"
                                  );
                                  console.log(
                                    bookunitSessions.filter(
                                      (x) => x?.UnitId === subject?.unitId
                                    ),
                                    "bookunitSessions"
                                  );
                                  setCoverUnitOpen(false);
                                  setCoverReportOpen(false);
                                  setCoverSessionOpen(true);
                                  setviewedUnitName(subject.unitName);
                                  FetchAllSessionAnalytics(
                                    subject?.bookId,
                                    bookunitSessions.filter(
                                      (x) => x?.UnitId === subject?.unitId
                                    )?.length > 0
                                      ? bookunitSessions.filter(
                                          (x) => x?.UnitId === subject?.unitId
                                        )[0]?.SessionDetails
                                      : ""
                                  );
                                }}
                              >
                                {subject.unitName}
                              </h3>

                              <div className="d-flex gap10px">
                                <div className="report-circle">
                                  {" "}
                                  <div>
                                    {" "}
                                    {subject?.booksProgress?.student
                                      ?.overAllStudentCount > 0
                                      ? Math.round(
                                          (subject?.booksProgress?.student
                                            ?.overAllStudentCount *
                                            100) /
                                            subject?.booksProgress?.total
                                              ?.overAllCount
                                        )
                                      : 0}
                                    %{" "}
                                  </div>{" "}
                                  <div className="report-circlespan">
                                    Unit Coverage
                                  </div>{" "}
                                </div>

                                <div className="w-100">
                                  {/* Items */}
                                  <div className="report-items">
                                    {coverageArr?.length > 0 &&
                                      coverageArr?.map((item) => (
                                        <>
                                          {subject?.booksProgress?.total[
                                            item?.totalCount
                                          ] &&
                                          subject?.booksProgress?.total[
                                            item?.totalCount
                                          ] > 0 &&
                                          item?.unitStatus ? (
                                            <div className="report-item">
                                              <div className="report-label d-flex justify-content-between">
                                                <span>
                                                  {item.label}{" "}
                                                  <span className="font-weight-600">
                                                    {
                                                      subject?.booksProgress
                                                        ?.student[
                                                        item?.studentCount
                                                      ]
                                                    }
                                                    /
                                                    {
                                                      subject?.booksProgress
                                                        ?.total[
                                                        item?.totalCount
                                                      ]
                                                    }
                                                  </span>
                                                </span>
                                                <span className="font-weight-600">
                                                  {`${
                                                    subject?.booksProgress
                                                      ?.total[
                                                      item?.totalCount
                                                    ] === 0
                                                      ? 0
                                                      : subject?.booksProgress
                                                          ?.student[
                                                          item?.studentCount
                                                        ]
                                                      ? subject?.booksProgress
                                                          ?.student[
                                                          item?.studentCount
                                                        ] >
                                                        subject?.booksProgress
                                                          ?.total[
                                                          item?.totalCount
                                                        ]
                                                        ? "100"
                                                        : Math.round(
                                                            (subject
                                                              ?.booksProgress
                                                              ?.student[
                                                              item?.studentCount
                                                            ] *
                                                              100) /
                                                              subject
                                                                ?.booksProgress
                                                                ?.total[
                                                                item?.totalCount
                                                              ]
                                                          )
                                                      : 0
                                                  }%`}
                                                </span>
                                              </div>
                                              <div className="report-bar">
                                                <div
                                                  className="report-bar-fill"
                                                  style={{
                                                    width: `${
                                                      subject?.booksProgress
                                                        ?.total[
                                                        item?.totalCount
                                                      ] === 0
                                                        ? 0
                                                        : subject?.booksProgress
                                                            ?.student[
                                                            item?.studentCount
                                                          ]
                                                        ? subject?.booksProgress
                                                            ?.student[
                                                            item?.studentCount
                                                          ] >
                                                          subject?.booksProgress
                                                            ?.total[
                                                            item?.totalCount
                                                          ]
                                                          ? "100"
                                                          : Math.round(
                                                              (subject
                                                                ?.booksProgress
                                                                ?.student[
                                                                item
                                                                  ?.studentCount
                                                              ] *
                                                                100) /
                                                                subject
                                                                  ?.booksProgress
                                                                  ?.total[
                                                                  item
                                                                    ?.totalCount
                                                                ]
                                                            )
                                                        : 0
                                                    }%`,
                                                  }}
                                                >
                                                  {/* <span className="report-bar-percent">
                                      {`${subject?.booksProgress?.total[item?.totalCount] === 0 ? 0 : (subject?.booksProgress?.student[item?.studentCount] ? subject?.booksProgress?.student[item?.studentCount] > subject?.booksProgress?.total[item?.totalCount] ? "100" : Math.round((subject?.booksProgress?.student[item?.studentCount] * 100)/subject?.booksProgress?.total[item?.totalCount]) : 0)}%`}
                                    </span> */}
                                                </div>
                                              </div>
                                            </div>
                                          ) : item.totalCount === "" ? (
                                            <div className="report-item">
                                              <div className="report-label d-flex justify-content-between">
                                                <span>{item.label} </span>
                                                <span className="font-weight-600">
                                                  {
                                                    subject?.booksProgress
                                                      ?.student[
                                                      item?.studentCount
                                                    ]
                                                  }
                                                </span>
                                              </div>
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </>
                                      ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  )}

                {!coverReportOpen &&
                  !coverUnitOpen &&
                  coverSessionOpen &&
                  !feedbackbtnstatus && (
                    <div className="row justify-content-start py-3 padtwoperen">
                      {viewedBookName && (
                        <div className="d-flex mb-3">
                          <span className="title-crumb text-left">
                            {viewedBookName}
                          </span>
                          {viewedUnitName && (
                            <>
                              <span className="d-flex align-items-end">
                                {">>"}
                              </span>
                              <span className="title-crumb text-left">
                                {viewedUnitName}
                              </span>
                            </>
                          )}
                        </div>
                      )}
                      {coverageReportSession?.length > 0 &&
                        coverageReportSession?.map((subject) => (
                          <div className="col-md-4 mb-4 d-flex justify-content-center">
                            <div className="report-card w-100">
                              {/* Subject Title */}

                              <h3 className="report-title text-center">
                                {subject.SessionName}
                              </h3>

                              <div className="d-flex gap10px">
                                <div className="report-circle">
                                  {" "}
                                  <div>
                                    {" "}
                                    {subject?.booksProgress?.student
                                      ?.overAllStudentCount > 0
                                      ? Math.round(
                                          (subject?.booksProgress?.student
                                            ?.overAllStudentCount *
                                            100) /
                                            subject?.booksProgress?.total
                                              ?.overAllCount
                                        )
                                      : 0}
                                    %{" "}
                                  </div>{" "}
                                  <div className="report-circlespan">
                                    {subject.SessionName.includes("Page")
                                      ? `Page Coverage`
                                      : subject.SessionName.includes("Session")
                                      ? `Session Coverage`
                                      : `Session/Page Coverage`}
                                  </div>{" "}
                                </div>

                                <div className="w-100">
                                  {/* Items */}
                                  <div className="report-items">
                                    {coverageArr?.length > 0 &&
                                      coverageArr?.map((item) => (
                                        <>
                                          {subject?.booksProgress?.total[
                                            item?.totalCount
                                          ] &&
                                          subject?.booksProgress?.total[
                                            item?.totalCount
                                          ] > 0 &&
                                          item?.sessionStatus ? (
                                            <div className="report-item">
                                              <div className="report-label d-flex justify-content-between">
                                                <span>
                                                  {item.label}{" "}
                                                  <span className="font-weight-600">
                                                    {
                                                      subject?.booksProgress
                                                        ?.student[
                                                        item?.studentCount
                                                      ]
                                                    }
                                                    /
                                                    {
                                                      subject?.booksProgress
                                                        ?.total[
                                                        item?.totalCount
                                                      ]
                                                    }
                                                  </span>
                                                </span>
                                                <span className="font-weight-600">
                                                  {`${
                                                    subject?.booksProgress
                                                      ?.total[
                                                      item?.totalCount
                                                    ] === 0
                                                      ? 0
                                                      : subject?.booksProgress
                                                          ?.student[
                                                          item?.studentCount
                                                        ]
                                                      ? subject?.booksProgress
                                                          ?.student[
                                                          item?.studentCount
                                                        ] >
                                                        subject?.booksProgress
                                                          ?.total[
                                                          item?.totalCount
                                                        ]
                                                        ? "100"
                                                        : Math.round(
                                                            (subject
                                                              ?.booksProgress
                                                              ?.student[
                                                              item?.studentCount
                                                            ] *
                                                              100) /
                                                              subject
                                                                ?.booksProgress
                                                                ?.total[
                                                                item?.totalCount
                                                              ]
                                                          )
                                                      : 0
                                                  }%`}
                                                </span>
                                              </div>
                                              <div className="report-bar">
                                                <div
                                                  className="report-bar-fill"
                                                  style={{
                                                    width: `${
                                                      subject?.booksProgress
                                                        ?.total[
                                                        item?.totalCount
                                                      ] === 0
                                                        ? 0
                                                        : subject?.booksProgress
                                                            ?.student[
                                                            item?.studentCount
                                                          ]
                                                        ? subject?.booksProgress
                                                            ?.student[
                                                            item?.studentCount
                                                          ] >
                                                          subject?.booksProgress
                                                            ?.total[
                                                            item?.totalCount
                                                          ]
                                                          ? "100"
                                                          : Math.round(
                                                              (subject
                                                                ?.booksProgress
                                                                ?.student[
                                                                item
                                                                  ?.studentCount
                                                              ] *
                                                                100) /
                                                                subject
                                                                  ?.booksProgress
                                                                  ?.total[
                                                                  item
                                                                    ?.totalCount
                                                                ]
                                                            )
                                                        : 0
                                                    }%`,
                                                  }}
                                                >
                                                  {/* <span className="report-bar-percent">
                                      {`${subject?.booksProgress?.total[item?.totalCount] === 0 ? 0 : (subject?.booksProgress?.student[item?.studentCount] ? subject?.booksProgress?.student[item?.studentCount] > subject?.booksProgress?.total[item?.totalCount] ? "100" : Math.round((subject?.booksProgress?.student[item?.studentCount] * 100)/subject?.booksProgress?.total[item?.totalCount]) : 0)}%`}
                                    </span> */}
                                                </div>
                                              </div>
                                            </div>
                                          ) : item.totalCount === "" &&
                                            item?.type !== "bookmarks" ? (
                                            <div className="report-item">
                                              <div className="report-label d-flex justify-content-between">
                                                <span>{item.label} </span>
                                                <span className="font-weight-600">
                                                  {
                                                    subject?.booksProgress
                                                      ?.student[
                                                      item?.studentCount
                                                    ]
                                                  }
                                                </span>
                                              </div>
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </>
                                      ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  )}

                {!coverReportOpen &&
                  !coverUnitOpen &&
                  !coverSessionOpen &&
                  feedbackbtnstatus && (
                    <div className="row justify-content-start py-3 padtwoperen">
                      <h3 className="section-head text-left">
                        {userClassname} - &nbsp;
                        {UserProfileData?.userTypeId?.usertype} Feedback
                        Questionnaire
                      </h3>
                      {quesSections?.length > 0 &&
                        quesSections?.map((x) => (
                          <div className="col-md-12 mb-4 d-flex justify-content-center">
                            <div className="w-100">
                              {/* Subject Title */}

                              <h3 className="section-title text-left">
                                {x?.section?.name}
                              </h3>
                              <div className="w-100 d-flex">
                                {/* Items */}
                                <div className="question-items">
                                  {quesData.filter(
                                    (z) => z?.section?._id === x?.section?._id
                                  )?.length > 0 &&
                                    quesData
                                      .filter(
                                        (z) =>
                                          z?.section?._id === x?.section?._id
                                      )
                                      ?.map((item, g) => (
                                        <>
                                          <div className="question-item">
                                            <div className=" d-flex justify-content-between">
                                              <span>
                                                {g + 1}.&nbsp;{item?.question}
                                              </span>
                                            </div>
                                            <div className="option-items">
                                              {item?.questionType === "radio" &&
                                                item?.options?.length > 0 &&
                                                item?.options?.map((v) => (
                                                  <span className="option-item">
                                                    <input
                                                      type="radio"
                                                      name={item?._id}
                                                      value={v.option}
                                                      onChange={(e) =>
                                                        setAnswers((prev) => ({
                                                          ...prev,
                                                          [userClassname]: {
                                                            ...prev[
                                                              userClassname
                                                            ],
                                                            [item?._id]:
                                                              e.target.value,
                                                          },
                                                        }))
                                                      }
                                                      // Check if this option is selected for current class
                                                      checked={
                                                        answers[
                                                          userClassname
                                                        ]?.[item?._id] ===
                                                        v.option
                                                      }
                                                    />&nbsp;
                                                    {v.option}
                                                  </span>
                                                ))}
                                              {item?.questionType ===
                                                "textarea" && (
                                                <span className="w-100">
                                                  <textarea
                                                    className="w-100"
                                                    id={`textarea-${item?._id}`}
                                                    rows="4"
                                                    value={
                                                      answers[userClassname]?.[
                                                        item?._id
                                                      ] || ""
                                                    }
                                                    onChange={(e) =>
                                                      setAnswers((prev) => ({
                                                        ...prev,
                                                        [userClassname]: {
                                                          ...prev[
                                                            userClassname
                                                          ],
                                                          [item?._id]:
                                                            e.target.value,
                                                        },
                                                      }))
                                                    }
                                                  />
                                                </span>
                                              )}
                                            </div>
                                          </div>
                                        </>
                                      ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      {quesSections?.length > 0 && (
                        <div
                          className="d-flex justify-content-end "
                          onClick={() => {
                            if (allAnswered) {
                              SubmitFeedback();
                            }
                          }}
                        >
                          <button
                            style={{
                              cursor: allAnswered ? "pointer" : "not-allowed",
                            }}
                            className={" registerBtn"}
                          >
                            Submit
                          </button>
                        </div>
                      )}
                    </div>
                  )}
              </>
            )}
          </div>
        </div>
      </div>

      <ModalComponent
        show={feedBackModalOpen}
        onClick={() => setFeedBackModalOpen(false)}
        Title=""
        dialogClassName={"registerPopup"}
        isGradient={false}
        Content={
          <div className="d-flex flex-column align-items-center justify-content-center">
            <div className="mb-3">
              <svg
                width="80"
                height="80"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="10" fill="#28a745" opacity="0.2" />
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="#28a745"
                  strokeWidth="2"
                  fill="none"
                />
                <path
                  d="M7 12L10.5 15.5L17 9"
                  stroke="#28a745"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <h4
              className="text-center fw-bold mb-2"
              style={{ color: "#28a745" }}
            >
              Success!
            </h4>

            <p
              className="text-center fw-semibold mb-3"
              style={{ fontSize: "16px" }}
            >
              Your feedback has been submitted successfully.
            </p>

            <p className="text-center fw-semibold text-muted">Thank you!</p>
          </div>
        }
      />
    </div>
  );
};

export default Bookfetch;
